import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatBullet(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5Zm0 12.17a1.33 1.33 0 1 0-.001 2.659A1.33 1.33 0 0 0 4 16.67ZM7 19h14v-2H7v2Zm0-6h14v-2H7v2Zm0-8v2h14V5H7Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
